import { render } from "./AddBranch.vue?vue&type=template&id=887dd058&ts=true"
import script from "./AddBranch.ts?vue&type=script&lang=ts&external"
export * from "./AddBranch.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__